module.exports = __webpack_public_path__ + "static/media/Map C.77be774b.png";